const [d,l] = [document,location]

export default function CURRENT_NAV (q='[data-plugin="currentNav"]'){
  
  const init = () => {
    const containers = d.querySelectorAll(q)
    Array.prototype.forEach.call(containers, container => {
      scan( container.querySelectorAll('a[href]'),1 )
      const countCurrent = container.querySelectorAll('a.current').length
      const max_depth = container.dataset.maxdepth || 3;
      let i=2;
      while(max_depth >= i){
        if(countCurrent==0) scan( container.querySelectorAll('a[href]'),i )
        i++
      }
    })
  }
  const scan = (items,depth) => {
    const pathname = l.pathname.replace(/index\.php|index.html/,'')
    Array.prototype.forEach.call(items,item => {
      let href = item.getAttribute('href').replace(/https?:/,'')
      let cond = (pathname == '/' && href==l.origin.replace(/https?:/,''))? '\\/': href
      switch( depth ){
        case 1: cond = `^${cond.replace('/','\/')}$`; break
        case 2: cond = `^${cond.replace('/','\/')}([^/]+/)?$`; break
        case 3: cond = `^${cond.replace('/','\/')}([^/]+/)([^/]+/)?$`; break
      }
      const regex = new RegExp( cond )
      if(regex.test(pathname)) item.classList.add('current')
      else item.classList.remove('current')
    })
  }

  d.addEventListener('DOMContentLoaded',init)

}